import { Link } from "react-router-dom";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import Selected from "../../Inputs/Selected";
import CardHall from "../../Cards/CardHall";
import MainButton from "../../Buttons/MainButton";

export default function Enter_Results() {
  return (
    <>
      <Row>
        <Col lg={6} md={5}>
          <Title title="ادخال العلامات " />
        </Col>
      </Row>
      <Row justify={"around"}>
        <Col lg={10} md={5}>
          <Selected title="اسم المقرر">
            <option>AR</option>
            <option>EN</option>
            <option>FR</option>
          </Selected>
        </Col>
      </Row>

      <Row>
        <Col lg={3} md={5}>
          <div className="mx-4 mt-4 text-lg font-bold"> تاريخ التقديم :</div>
        </Col>
      </Row>

      <Row justify={"around"} className="!mt-5">
        <Col lg={3} md={4}>
          <Link to="hall">
            <CardHall title={"اسم القاعة"} CapacityHall={" عدد الحضور : 50"} />
          </Link>
        </Col>

        <Col lg={3} md={4}>
          <Link to="hall">
            <CardHall title={"اسم القاعة"} CapacityHall={" عدد الحضور : 50"} />
          </Link>
        </Col>
        <Col lg={3} md={4}>
          <Link to="hall">
            <CardHall title={"اسم القاعة"} CapacityHall={" عدد الحضور : 50"} />
          </Link>
        </Col>
        <Col
          lg={10}
          md={5}
          sm={11}
          className="flex lg:justify-end max-lg:mx-auto  !mt-8 "
        >
          <MainButton titlebtn="ادخال النتائج" className="w-[400px] " />
        </Col>
      </Row>
    </>
  );
}
